export const GAME_MODES = [
  'sword',
  'mace',
  'mace_rockets',
  'cpvp',
  'axe_shield',
  'nethpot',
  'tank'
] as const;

export type Gamemode = (typeof GAME_MODES)[number];

export function getGamemodeColor(gm: string): string {
  switch (gm) {
    case 'mace':
    case 'mace_rockets':
      return 'bg-[rgba(255,191,0,0.15)] text-[#ffbf00]';
    case 'sword':
    case 'cpvp':
      return 'bg-[rgba(224,60,60,0.15)] text-[#e03c3c]';
    case 'axe_shield':
      return 'bg-[rgba(76,175,80,0.15)] text-[#4caf50]';
    default:
      return 'bg-[rgba(255,255,255,0.08)] text-on-surface-variant';
  }
}

export function getGamemodeLabel(gm: string): string {
  if (gm === 'cpvp') return 'Crystal PvP';
  if (gm === 'axe_shield') return 'Axe PvP';
  if (gm === 'mace_rockets') return 'Mace Rockets';
  if (gm === 'nethpot') return 'Nethpot';
  return gm.charAt(0).toUpperCase() + gm.slice(1);
}
